export const PaymentStatus = {
  SUCCESS: 'success',
  ERROR: 'error',
  PENDING: 'pending',
  FAILED: 'failed',
  AUTHORISED: 'Authorised',
  TIMEOUT: 'TIMEOUT',
  PCI_PAL_ERROR: 'PCIPal Error'
};

export const Company = {
  EIL: 'EIL',
  EHL: 'EHL',
  THI: 'THI'
};

export const Location = {
  EBSC: 'EBSC',
  CSC: 'CSC'
};

export const FINCOM = 'FINCOM';
